
import { Stock, Signal } from '../app/data/mockData';

// 定义 data.json 中的数据结构 (与 generate_data.ts 保持一致)
interface RawStock {
  code: string;
  name: string;
  topic: string;
  price: {
    current: number;
    change: number;
    changePercent: number;
  };
  dates: {
    data: string;
    signal?: string;
    updateTime?: string;
  };
  rps: Record<string, number>;
  signals: {
    type: string;
    date: string;
    strength?: number;
  }[];
}

interface RawData {
  meta: {
    updateTime: string;
    version: string;
  };
  stocks: RawStock[];
}

export const processRawData = (data: RawData): { stocks: Stock[], signals: Signal[] } => {
  const stocks: Stock[] = [];
  const signals: Signal[] = [];

  data.stocks.forEach((rawStock, index) => {
    // 转换 Stock 对象
    const stock: Stock = {
      id: rawStock.code, // 使用 code 作为 id
      code: rawStock.code,
      name: rawStock.name,
      topic: rawStock.topic,
      change: rawStock.price.change,
      changePercent: rawStock.price.changePercent,
      rps10: rawStock.rps['10'],
      rps20: rawStock.rps['20'],
      rps50: rawStock.rps['50'],
      rps120: rawStock.rps['120'],
      rps250: rawStock.rps['250'],
      signalDate: rawStock.dates.signal,
      dataDate: rawStock.dates.data
    };

    stocks.push(stock);

    // 转换 Signal 对象
    rawStock.signals.forEach((rawSignal, signalIndex) => {
      // 映射信号类型到 category
      let category: 'oneil' | 'magic' = 'oneil';
      if (['profit_gap', 'stage2'].includes(rawSignal.type)) {
        category = 'magic';
      }

      // 映射信号类型名称 (如果前端需要中文)
      let displayType = rawSignal.type;
      if (rawSignal.type === 'pocket_pivot') displayType = '口袋支点';
      else if (rawSignal.type === 'new_high') displayType = '一年新高'; // 或 '新高突破'
      else if (rawSignal.type === 'three_line_red') displayType = '三线翻红';
      else if (rawSignal.type === 'profit_gap') displayType = '净利润断层';
      else if (rawSignal.type === 'stage2') displayType = '二阶段';

      signals.push({
        id: `${stock.code}-${rawSignal.type}-${rawSignal.date}`,
        stock: stock,
        signalType: displayType,
        signalStrength: rawSignal.strength || 3, // 默认强度
        category: category
      });
    });
  });

  return { stocks, signals };
};
